const SOPHIA = window.SOPHIA || {}

SOPHIA.sophyOverlay = (function () {
  const api = {
    current: [],
    keyboardHandler: null,

    open(content, userOptions = {}, focusElement) {
      if (!userOptions.leaveOpen && api.current.length) api.close()

      const defaultOptions = {
        autoFocus: true,
        backFocus: true,
        clickSlide: true,
        keyboard: true,
        baseClass: '',
        notToClone: false,
        simpleDesign: false,
        btnTpl: {
          smallBtn: '<button data-sophypop-close class="sophypop-close-small" aria-label="Close"></button>'
        },
        baseTpl: `
          <div class="sophypop-container" role="dialog" tabindex="-1" aria-label="Overlay">
            <div class="sophypop-bg"></div>
            <div class="sophypop-inner">
              <div class="sophypop-innerbox"></div>
            </div>
          </div>
        `,
        beforeShow: function() {
          if (!options.doNotFocus) {

            if (!$('.rating_histogram_inner').is(':visible')) {
              $('a:visible, input:visible, textarea, select', $('.sophypop-inner')).eq(0).trigger('focus')
            }

            if ($('#adopt_cancel').length > 0 && $('#choicesList li a:visible').length == 0) {
              $('#adopt_cancel').trigger('focus')
            }
          }

          // lock background
          lockBodyScroll();

          $('a.close-popup').on('focus', function(e) {
            e.preventDefault()
            api.close()
          })
        },
        afterLoad: null,
        afterShow: function() {
          if (focusElement != 'undefined' && typeof focusElement == 'object') {
            if (focusElement != 'undefined' && !$(focusElement).hasClass('stars'))
            $('a:visible, input:visible, textarea, select, button', $('.sophypop-inner')).eq(0).trigger('focus')
          }
          if (options && typeof(options['addCompleteFunc']) == 'function') {
            options['addCompleteFunc']()
          }

          $(window).on('beforeunload', function(){
            api.close()
          })
        },
        beforeClose: function() {
          if (focusElement != 'undefined' && typeof focusElement == 'object') {
            $(focusElement).trigger('focus')
          }
          if (options && typeof(options['addCleanupFunc']) == 'function') {
            options['addCleanupFunc']()
          }
        },
        afterClose: () => {
          // unlock background
          unlockBodyScroll();
        }
      }

      const options = mergeOptions(defaultOptions, userOptions);

      const $overlay = $(options.baseTpl).addClass(options.baseClass)
      const $slide = $overlay.find('.sophypop-innerbox')
      let $content
      let $originalParent
      let $nextSibling

      if (options.notToClone) {
        if (options.notToClone) {
          $content = $(content)
          $originalParent = $content.parent()
          $nextSibling = $content.next() // could be empty if it's the last child
        }
      } else {
        if (content?.type === 'inline') {
          $content = $(content.src).clone(true, true).show()
        } else {
          $content = $(content).clone(true, true).show()
        }
      }

      $slide.append($content.addClass('sophypop-content'))

      if (options.btnTpl?.smallBtn) {
        const $closeButton = $(options.btnTpl.smallBtn)
        if (options.externalCloseButton) {
          $slide.append($closeButton)
        } else if (options.btnTpl.smallBtn !== 'false') {
          $content.append($closeButton)
        }
      }

      // beforeShow
      if (typeof options.beforeShow === 'function') {
        options.beforeShow($content)
      }

      if (options.baseClass == 'full-page') {
        // remove body scroll if full screen popup
        $('body').addClass('sophypop-no-scroll');
      }

      // Append Overlay
      $('body').append($overlay)

      // afterLoad
      if (typeof options.afterLoad === 'function') {
        options.afterLoad($content)
      }

      $(document).trigger('sophiaOverlay:afterLoad', [$content, options]);

      api.current.push({ $overlay, options, $content, $originalParent, $nextSibling })

      if (options.clickSlide) {
        $overlay.find('.sophypop-innerbox').on('click', (e) => {
          if (!$(e.target).hasClass('sophypop-content') && !$(e.target).parents().hasClass('sophypop-content')) {
            api.close()
          }
        })
      }

      $overlay.find('[data-sophypop-close]').on('click', (e) => {
        e.preventDefault()
        api.close()
      })

      // Bind Escape key handler only once for all overlays
      if (options.keyboard && !api.keyboardHandler) {
        api.keyboardHandler = (e) => {
          if (e.key === 'Escape') {
            api.close()
          }
        }
        $(document).on('keydown.sophypop', api.keyboardHandler)
      }

      requestAnimationFrame(() => {
        $overlay.addClass('sophypop-is-open')

        setTimeout(() => {
          // afterShow
          if (typeof options.afterShow === 'function') {
            options.afterShow($content)
          }

          $(document).trigger('sophiaOverlay:afterShow', [$content, options]);

          if (options.autoFocus) {
            $overlay.trigger('focus')
          }
        }, 0)
      })
    },

    close() {
      $('body').removeClass('sophypop-no-scroll');

      if (!api.current.length) return

      const { $overlay, options, $content, $originalParent, $nextSibling } = api.current.pop() // pop the last (topmost) popup

      // beforeClose
      if (typeof options.beforeClose === 'function') {
        options.beforeClose($content)
      }

      $overlay.removeClass('sophypop-is-open')

      setTimeout(() => {
        if (options.notToClone) {
          $content.removeClass('sophypop-content')
          if ($originalParent && $originalParent.length) {
            if ($nextSibling && $nextSibling.length) {
              $content.insertBefore($nextSibling)
            } else {
              $originalParent.append($content);
            }
          }
          $overlay.remove(); // remove empty container
        } else {
          $overlay.remove()
        }

        // afterClose
        if (typeof options.afterClose === 'function') {
          options.afterClose($content)
        }

        $(document).trigger('sophiaOverlay:afterClose', [$content, options]);

        // Remove keyboard handler only if there are no overlays left
        if (!api.current.length && api.keyboardHandler) {
          $(document).off('keydown.sophypop', api.keyboardHandler)
          api.keyboardHandler = null
        }

        if (options.backFocus && $content && $content.data('focus-element')) {
          $content.data('focus-element').trigger('focus')
        }
      }, 1000)
    },

    getInstance() {
      return api.current.length ? api.current[api.current.length - 1] : null // the last (topmost) popup
    },

    destroy() {
      api.close()
      api.current = []
    }
  }

  return api
})()

SOPHIA.preloader = (function () {
  const api = {
    current: null,
    open() {
      if (api.current) api.close()

      const html = `
          <div class="preloader-popup" role="dialog" tabindex="-1" aria-label="Overlay">
            <div class="sophypop-bg"></div>
            <div class="sophypop-inner">
              <div class="sophypop-innerbox">
                <div class="sophypop-content sophypop-loading"></div>
              </div>
            </div>
          </div>
        `

      const $overlay = $(html)

      $('body').append($overlay)

      api.current = {
        $overlay,
      }

      requestAnimationFrame(() => {
        $overlay.addClass('sophypop-is-open')
      })
    },

    close() {
      if (!api.current) return

      const { $overlay } = api.current
      $overlay.remove()
    }
  }

  return api
})()

function mergeCallbacks(defaultFn, userFn) {
  return function (...args) {
    if (typeof defaultFn === 'function') defaultFn.apply(this, args);
    if (typeof userFn === 'function') userFn.apply(this, args);
  };
}

function mergeOptions(defaultOptions, userOptions) {
  const options = { ...defaultOptions, ...userOptions };

  // List all lifecycle hooks you want to support
  const hooks = ['beforeShow', 'afterLoad', 'afterShow', 'beforeClose', 'afterClose'];

  hooks.forEach(hook => {
    if (userOptions[hook] || defaultOptions[hook]) {
      options[hook] = mergeCallbacks(defaultOptions[hook], userOptions[hook]);
    }
  });

  return options;
}

let scrollPosition = 0
let lockCount = 0 // nested popups count

function lockBodyScroll() {
  // lock the body once
  if (lockCount === 0) {
    scrollPosition = $(window).scrollTop();

    $('body').css({
      position: 'fixed',
      top: -scrollPosition + 'px',
      left: '0',
      right: '0',
      overflow: 'hidden',
      width: '100%'
    });
  }
  lockCount++;
}

function unlockBodyScroll() {
  lockCount--;

  if (lockCount <= 0) {
    lockCount = 0;

    $('body').css({
      position: '',
      top: '',
      left: '',
      right: '',
      overflow: '',
      width: ''
    });

    $(window).scrollTop(scrollPosition);
  }
}
